import { RxExclamationTriangle } from 'react-icons/rx'
import { red } from '~/common/styles/colors'
import { Text } from '~/components/ui/atoms/text/Text'

interface ErrorMessageProps {
  message: string
}

/**
 * Renders an error message with an icon
 */
export function ErrorMessage({ message }: ErrorMessageProps) {
  return (
    <div className="border-1 m-2 flex w-fit items-center justify-start gap-2 rounded-[2px] border border-red-11 bg-red-3 p-2">
      <RxExclamationTriangle className="shrink-0" color={red[11]} />
      <Text>{message}</Text>
    </div>
  )
}
